export type SubnavParam = 'drafts' | 'all-campaigns';
export type TypeParam = 'text' | 'email';
export type ViewParam = 'editor' | 'compose' | 'templates' | 'new-email';

export const isValidSubNav = (subNav: string): subNav is SubnavParam => {
  return (['drafts', 'all-campaigns'] satisfies SubnavParam[]).includes(subNav as SubnavParam);
};

export const isValidType = (type: string): type is TypeParam => {
  return (['text', 'email'] satisfies TypeParam[]).includes(type as TypeParam);
};

export const isValidView = (view: string): view is ViewParam => {
  return (['editor', 'compose', 'templates', 'new-email'] satisfies ViewParam[]).includes(view as ViewParam);
};
